import React,{useEffect, useState} from "react";
import SmallFooter from "../componants/footer/smallFooter";
import ScrollTop from "../componants/scrollTop";
import PersonalNavbarPages from "./navbar/personalNavbarPages";

export default function CookiesPolicy(){
    return(
        <>
        <PersonalNavbarPages items={[{titulo:'Política de cookies', 'id':'politicaCookies'}]} />

        <section className="section mt-5" id="politicaCookies" style={{ paddingTop:'1rem' }}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title mb-4">
                            <h4 className="title mb-4"><br/>POLÍTICA DE COOKIES</h4>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-12">
                        <p style={{textAlign:'justify'}}>
                            El sitio web de Pilates Rizzo, S.L. utiliza cookies. Usted puede cambiar la
                            configuración o retirar su consentimiento de las cookies de nuestra web en cualquier
                            momento.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            Esta página utiliza tipos diferentes de cookies. Solo se almacenarán cookies en su
                            dispositivo si son estrictamente necesarias para el correcto funcionamiento del sitio
                            web. Para todos los demás tipos de cookies necesitamos su consentimiento mediante
                            la activación de la casilla correspondiente.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            También utilizamos cookies de analítica web para medir y analizar la navegación de
                            los usuarios en nuestra página web, y botones sociales para que puedas compartir
                            fácilmente nuestro contenido (Botón “Seguir” de Instagram).
                        </p>
                        <p style={{textAlign:'justify'}}>
                            Puede obtener más información sobre nosotros y cómo contactarnos en nuestro Aviso
                            legal y de cómo tratamos los datos personales en nuestra Política de Privacidad.
                        </p>
                        <h5>¿QUÉ SON LAS COOKIES?</h5>
                        <p style={{textAlign:'justify'}}>
                            Una cookie es un fichero que se descarga en su dispositivo a través de la web. Las
                            cookies permiten a una página web, entre otras cosas, hacer funcione correctamente,
                            almacenar y recuperar información sobre los hábitos de navegación de un usuario o de
                            su dispositivo y, dependiendo de la información que contengan y de la forma en que
                            utilice su dispositivo, pueden utilizarse para reconocer al usuario.
                        </p>
                        <h5>TIPOS DE COOKIES</h5>
                        <ul>
                            <li style={{display:'none'}}></li>
                            <li><span className="h6" style={{textAlign:'justify'}}>Cookies técnicas y funcionales:</span> son las estrictamente necesarias para el uso del sitio web y para la prestación del servicio contratado.</li>
                            <li><span className="h6" style={{textAlign:'justify'}}>Cookies analíticas:</span> recogen información del uso que se realiza del sitio web.</li>
                            <li><span className="h6" style={{textAlign:'justify'}}>Cookies de preferencias y personalización:</span> Son aquéllas que permiten al
                                usuario acceder al servicio con algunas características de carácter general
                                predefinidas en función de una serie de criterios en el dispositivo del usuario
                                como por ejemplo serian el idioma, el tipo de navegador a través del cual
                                accede al servicio, la configuración regional desde donde accede al servicio,
                                etc..</li>
                            <li><span className="h6" style={{textAlign:'justify'}}>Cookies sociales:</span> son aquellas necesarias para redes sociales externas..</li>
                            <li><span className="h6" style={{textAlign:'justify'}}>Cookies de publicidad y comportamentales:</span> recogen información sobre las
                            preferencias y elecciones personales del usuario (retargeting)</li>
                        </ul>
                        <h5>¿QUÉ TIPOS DE COOKIES UTILIZA ESTA PÁGINA WEB?</h5>
                        <p className="h6">Necesarias (Técnicas)</p>
                        <p style={{textAlign:'justify'}}>
                            Las cookies necesarias activan las funciones básicas como la navegación en la página
                            y el acceso a áreas seguras de la página web. La página web no puede funcionar
                            adecuadamente sin estas cookies.
                        </p>
                        <p className="h6">Analíticas</p>
                        <p style={{textAlign:'justify'}}>
                            Las cookies estadísticas ayudan a los propietarios de páginas web a comprender
                            cómo interactúan los visitantes con las páginas web reuniendo y proporcionando
                            información de forma anónima.
                        </p>
                        <p className="h6">Sociales</p>
                        <p style={{textAlign:'justify'}}>
                            Son esos botones que permiten compartir el contenido del sitio web en sus redes
                            sociales (Facebook, Twitter y Linkedin, previo tu consentimiento y login) a través de
                            sistemas totalmente gestionados por dichas redes sociales, así como los recursos (pej.
                            videos) y material que se encuentra en nuestra web, y que de igual manera se presta y
                            gestiona completamente por un tercero.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            Si no acepta estas cookies, no podrá compartir nuestro contenido a través de los
                            botones, y en su caso, no podrás visualizar el contenido de terceros que hayamos
                            incrustado en el sitio.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            El sitio web que está visitando utiliza cookies para mejorar la navegación y obtener
                            datos estadísticos. Las cookies son archivos de texto que se instalan en el ordenador
                            desde el que se accede a esta página y que envían información automáticamente a
                            nuestro servidor. Las cookies no son virus informáticos. No dañan su ordenador ni
                            ralentizan su funcionamiento. Puede eliminarlas en cualquier momento o rechazarlas
                            configurando el programa de navegación que utilice.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            <span className="h6">Google Analytics:</span> Este <span className="h6">sitio web utiliza Google Analytics</span>, el servicio de análisis
                            web. Este servicio es prestado por Google Inc, 1600 Amphitheatre Parkway, Mountain
                            View, CA 94043, EE.UU. Google Analytics utiliza «cookies». Las cookies son archivos
                            de texto almacenados en su dispositivo que nos permiten estudiar cómo utiliza este
                            sitio web. La información generada sobre el uso de este sitio web y almacenada en la
                            cookie es transmitida y archivada por Google en sus servidores de Estados Unidos. El
                            interés en almacenar cookies de Google Analytics se basa en el Art. 6 (1) (f) de la
                            legislación GDPR. El operador de este sitio web tiene un interés legítimo en analizar el
                            comportamiento de los usuarios con el fin de optimizar el sitio web y su publicidad.
                        </p>
                        <p style={{textAlign:'justify'}}>
                            <span className="h6">IP anónimas</span> En este <span className="h6">sitio web hemos activado las IP anónimas</span>. Su dirección IP
                            será acortada por Google dentro de la Unión Europea así como en otros lugares que
                            hayan firmado el Acuerdo con el Espacio Económico Europeo antes de que la
                            información sea transmitida a Estados Unidos. Sólo en casos excepcionales se
                            enviará la dirección IP completa al servidor de Google en EE.UU. y se acortará allí.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <SmallFooter/>
        <ScrollTop/>

        </>
    )
}

// rosa: #dacbd2
// lila: #735fb3
// verde: #bdcec8
